import useThunkReducer from 'react-hook-thunk-reducer';
import React, { useMemo } from 'react';
import NextTreeContext from './NextTreeContext';
import createTreeReducer from './reducer';
const NextTreeStore = ({ children }) => {
    const [state, dispatch] = useThunkReducer(createTreeReducer(), {});
    const value = useMemo(() => ({ state, dispatch }), [state, dispatch]);
    return (<NextTreeContext.Provider value={value}>
      {children}
    </NextTreeContext.Provider>);
};
export default NextTreeStore;
